// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthorizedApp__container___9of-H","content":"AuthorizedApp__content___Scpt8","hasModal":"AuthorizedApp__hasModal___E9MLj"};